/* eslint-disable no-restricted-imports */
import { Children, FC, ReactNode, isValidElement } from 'react';
import { Box } from '@mui/material';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import {
	toPersonalizationEspot,
	usePersonalizationPercentage,
} from '@/data/Content/RepurchaseCoupon';

type Props = {
	ems?: string;
	children?: ReactNode;
};

export const DpPersonalizationCampaign: FC<Props> = ({ ems, children }) => {
	const percentage = usePersonalizationPercentage();

	const cleanChildren = Children.toArray(children).filter((child) => isValidElement(child));

	if (!percentage) {
		return <>{cleanChildren}</>;
	}

	if (!ems) {
		return null;
	}

	const emsName = toPersonalizationEspot(ems, percentage);

	return (
		<ContentRecommendation
			id={emsName}
			properties={{ emsName }}
			withoutFrame
			loadingElement={<Box />}
			emptyElement={<>{cleanChildren}</>}
		/>
	);
};
